import { render, staticRenderFns } from "./HeaderBar.vue?vue&type=template&id=ef795e02&lang=pug"
import script from "./HeaderBar.vue?vue&type=script&lang=ts"
export * from "./HeaderBar.vue?vue&type=script&lang=ts"
import style0 from "./HeaderBar.vue?vue&type=style&index=0&id=ef795e02&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports